import { Tab as AriaTab, TabProps as AriaTabProps } from 'react-aria-components';
import { css } from '@allenai/varnish-panda-runtime/css';

import { type PropsWithChildren, type ReactNode } from 'react';

import { cx } from '@/utils/cx';

import focusRing from '@/components/shared/focusRing.styles';

import TabsRecipeProps, { tabsRecipe } from './tabs.styles';

interface TabProps extends AriaTabProps, TabsRecipeProps {
    children?: ReactNode;
    className?: string;
}

const Tab = ({ className, children, ...rest }: PropsWithChildren<TabProps>) => {
    const [variantProps, localProps] = tabsRecipe.splitVariantProps(rest);
    // `raw` receipe is required to be able to merge css objects (used in focus ring)
    const recipeClassNames = tabsRecipe(variantProps);

    return (
        <AriaTab {...localProps} className={cx(css(focusRing), recipeClassNames.tab, className)}>
            {children}
        </AriaTab>
    );
};

export { Tab };
export type { TabProps };
